import { Pipe, PipeTransform } from '@angular/core';

import { PipeFunctions } from './_pipe.functions';

@Pipe({
    name: 'formatVsnr',
    standalone: false
})
export class VsnrTranformationPipe implements PipeTransform {

    transform(raw: string): string {
        return PipeFunctions.formatVsnr(raw);
    }

}
